import { compose, createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import createRootReducer from 'reducers';
import { DASHBOARD, REFERRAL, HEADER } from '_constants';

const restrictedActions = [DASHBOARD.ANIMATE_COUNTER, REFERRAL.ACTION.SEARCH, HEADER.TOGGLE_READ_LOADER, HEADER.TOGGLE_WRITE_LOADER];

export const history = createBrowserHistory();

const middlewares = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV === 'development') {
  const { createLogger } = require('redux-logger');

  middlewares.push(createLogger({
    predicate: (getState, action) => restrictedActions.indexOf(action.type) === -1
  }));
}

export const configureStore = (preloadedState) => {
  const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    createRootReducer(history),
    preloadedState,
    composeEnhancer(applyMiddleware(...middlewares))
  );

  if (module.hot) {
    module.hot.accept('reducers', () => {
      store.replaceReducer(createRootReducer(history));
    });
  }

  return store;
};
